import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
  TableCell,
  Paper,
  TableBody,
  Button,
  TablePagination,
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import { getGradingPublish } from '../../../../Utils/apiServices';
import KenLoader from '../../../../Components/KenLoader';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  main: {
    padding: '32px 0px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: ' ',
  },
  medium: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
  },
  normal: {
    // color: '#505F79',
    color: 'white',

    background: 'green',
    // background: '#27AE60',

    // background: 'white',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'green',

      color: 'white',
      // border: '1px solid white',
    },
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    color: 'white',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
  },
  editbtn: {
    color: '##272727',

    background: 'rgba(0, 33, 141,0.2)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(0, 33, 141,0.2)',

      color: '##272727',
    },
  },
  publishView: {
    color: 'white',
    background: '#55b0cd',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
  },
  view: {
    color: 'white',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({}))(TableCell);
const StyledTableRow = withStyles((theme) => ({}))(TableRow);

const ModerationList = ({
  course,
  setCourse,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  totalData,
  loading,
}) => {
  const classes = useStyles();
  const onPublishClick = (status, id) => {
    getGradingPublish(status, id)
      .then((res) => {
        console.log('resresresreresrrACk', res);
      })
      .catch((err) => {
        console.log('errorr', err);
      });
  };

  return (
    <Box>
      {loading && <KenLoader />}
      <TableContainer
        component={Paper}
        style={{ padding: '16px', marginTop: 16 }}
      >
        <Table>
          <TableHead className="tableHeader">
            <TableRow>
              <StyledTableCell className="tableHeaderTitle">
                COURSE
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                TERM
              </StyledTableCell>{' '}
              <StyledTableCell className="tableHeaderTitle">
                EXAM CYCLE
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                BATCH
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                DATE OF EXAM
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                SUBJECT FACULTY
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                STATUS
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle" colSpan={2}>
                ACTIONS
              </StyledTableCell>
            </TableRow>
          </TableHead>{' '}
          <TableBody className="tablebody1">
            {course?.map((ele, index) => {
              return (
                <StyledTableRow key={ele?.courseName}>
                  <StyledTableCell>{ele?.courseName}</StyledTableCell>
                  <StyledTableCell>{ele?.term}</StyledTableCell>{' '}
                  <StyledTableCell>{ele?.examCycle}</StyledTableCell>
                  <StyledTableCell>{ele?.batch}</StyledTableCell>
                  <StyledTableCell>
                    {ele?.deadline
                      ? moment(ele?.deadline).format('DD-MM-YYYY')
                      : ''}
                  </StyledTableCell>
                  <StyledTableCell>{ele?.subjectFaculty}</StyledTableCell>
                  <StyledTableCell>
                    <Button
                      className={
                        ele?.status && ele?.status === 'Under process'
                          ? classes.medium
                          : ele?.status === 'Approved'
                          ? classes.normal
                          : classes.error
                      }
                      /* style={{
                          backgroundColor:
                            ele?.status && ele?.status === 'Under process'
                              ? '#F2994A'
                              : ele?.status === 'Approved'
                              ? '#27AE60'
                              : '#EB5757',
                        }} */
                    >
                      {ele?.status}
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Button
                      className={classes.view}
                      // color="primary"
                      size="small"
                      variant="primary"
                    >
                      <Link
                        to={{
                          pathname: `${routes.moderation}/details/${ele?.courseOfferingId}`,
                          state: { gradingId: ele?.courseOfferingId },
                        }}
                      >
                        View / Edit
                      </Link>
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell>
                    {/* <Button
                      className={classes.publishView}
                      size="small"
                      variant="primary"
                      onClick={() => onPublishClick(ele?.status, ele?.id)}
                    >
                      Publish
                    </Button> */}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            colSpan={6}
            count={totalData ? totalData : course.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ModerationList;
